import React from 'react'
import EirConfirmation from '../eir-confirmation/EirConfirmation'
import { useLocation } from 'react-router-dom';

export const EirConfirmationContainer=(props)=> {
    const { setCurrentUrl ,feedbackUrl} = props;
    const location = useLocation();
    const currentUrl = location.pathname;
    setCurrentUrl(currentUrl);

    return (

        <div>
            <EirConfirmation feedbackUrl={feedbackUrl} />
        </div>
    )
}



